import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './cardBodyStyle.js'

export default function CardBody(props) {
  const {
    className,
    children,
    background,
    plain,
    formHorizontal,
    pricing,
    signup,
    color,
    profile,
    calendar,
    sx,
    ...rest
  } = props

  return (
    <Box
      component={'div'}
      sx={[
        sx,
        styles.cardBody,
        background && styles.cardBodyBackground,
        plain && styles.cardBodyPlain,
        formHorizontal && styles.cardBodyFormHorizontal,
        pricing && styles.cardPricing,
        signup && styles.cardSignup,
        color && styles.cardBodyColor,
        profile && styles.cardBodyProfile,
        calendar && styles.cardBodyCalendar,
      ]}
      className={className}
      {...rest}
    >
      {children}
    </Box>
  )
}

CardBody.propTypes = {
  className: PropTypes.string,
  background: PropTypes.bool,
  plain: PropTypes.bool,
  formHorizontal: PropTypes.bool,
  pricing: PropTypes.bool,
  signup: PropTypes.bool,
  color: PropTypes.bool,
  profile: PropTypes.bool,
  calendar: PropTypes.bool,
  children: PropTypes.node,
}
